/** @format */

// import { Auth } from '../modules/auth/Auth'
// import { notificationConstants } from '../modules/notifications/notifications'
import { store } from '../core/store';

const _ = require('underscore');

export const StoreHelper = {
    styleGreen: 'padding: 5px; background-color: black; font-size: 24px; color: green;',
    styleRed: 'padding: 5px; background-color: black; margin-top: 10px; margin-bottom: 10px; font-size: 24px; color: red;',

    requiresStore: (component, storeName) => {
        if (typeof component !== 'object') {
            console.error(
                '%c !!! %c Incorrectly supplied component for the StoreHelper. Follow the stack to fix the issue %c !!!',
                StoreHelper.styleGreen,
                StoreHelper.styleRed,
                StoreHelper.styleGreen
            );
            throw new Error('Incorrectly supplied component for the StoreHelper. Follow the stack to fix the issue');
        }
        if (!storeName) {
            console.error('%c !!! %c StoreName is required %c !!!', StoreHelper.styleGreen, StoreHelper.styleRed, StoreHelper.styleGreen);
            throw new Error('StoreName is required');
        }
        if (!store.asyncReducers[storeName]) {
            console.error(
                '%c !!! %c Component ' +
                    component.constructor.name +
                    ' requires ' +
                    storeName +
                    ' reducer but no instance was found in the store %c !!!',
                StoreHelper.styleGreen,
                StoreHelper.styleRed,
                StoreHelper.styleGreen
            );
            throw new Error('Component ' + component.constructor.name + ' requires ' + storeName + ' reducer but no instance was found in the store');
        }

        return true;
    },

    requiresStores: (component, storeNames) => {
        _.each(storeNames, (storeName) => {
            StoreHelper.requiresStore(component, storeName);
        });
    },
};
